module.exports = __webpack_public_path__ + "img/share.3fa41e50.png";